import {
  siApachespark, siDataiku, siDocker, siExpo, siFastapi, siFirebase, siGit, siGithubactions, siJavascript, siJupyter, siLangchain, siMongodb, siNextdotjs, siNodedotjs, siOpenjdk, siPandas, siPostgresql, siPython, siR, siReact, siRedis, siScikitlearn, siSnowflake, siStreamlit, siSupabase, siTailwindcss, siTalend, siTypescript, siUv, siVite, siWebassembly,
} from 'simple-icons';

// Logos officiels (Simple Icons, CC0). Les marques absentes de Simple Icons ont un monogramme.
const MAP = {
  Python: siPython, ReactJS: siReact, React: siReact, 'React Native': siReact, FastAPI: siFastapi,
  Docker: siDocker, Snowflake: siSnowflake, PostgreSQL: siPostgresql, MongoDB: siMongodb,
  Firebase: siFirebase, TypeScript: siTypescript, JavaScript: siJavascript, 'Node.js': siNodedotjs,
  'Next.js': siNextdotjs, 'Apache Spark': siApachespark, Git: siGit, Java: siOpenjdk, Talend: siTalend,
  Dataiku: siDataiku, Expo: siExpo, 'Tailwind CSS': siTailwindcss, Supabase: siSupabase, Redis: siRedis,
  Vite: siVite, R: siR, Jupyter: siJupyter, Pandas: siPandas, 'Scikit-learn': siScikitlearn,
  LangChain: siLangchain, 'GitHub Actions': siGithubactions, Streamlit: siStreamlit, uv: siUv,
  WebAssembly: siWebassembly, SQL: siPostgresql,
};

// couleurs trop sombres pour un fond sombre : on les éclaircit
const DARK_HEX = new Set(['000000', '1C2024', '150458']);

export function hasLogo(name) {
  return !!MAP[name];
}

export default function TechIcon({ name, size = 18, mono = false, className = '' }) {
  const icon = MAP[name];
  if (!icon) {
    return (
      <span aria-hidden="true" className={`inline-flex items-center justify-center rounded-md bg-duna-pill text-duna-pillText font-bold ${className}`} style={{ width: size, height: size, fontSize: size * 0.45 }}>
        {name.replace(/[^A-Za-z]/g, '').slice(0, 2)}
      </span>
    );
  }
  const fill = mono ? 'currentColor' : DARK_HEX.has(icon.hex) ? 'rgb(var(--duna-text))' : `#${icon.hex}`;
  return (
    <svg role="img" aria-label={name} viewBox="0 0 24 24" width={size} height={size} className={className} fill={fill}>
      <path d={icon.path} />
    </svg>
  );
}
